(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Safari su iOS applica :active solo se il documento ha almeno un listener
  // di tocco: senza questa riga lo stato premuto dei bottoni (punto 10
  // dell'audit) funzionerebbe su desktop e non sul telefono, che e' esattamente
  // il dispositivo per cui e' stato fatto. Il listener e' vuoto e passivo:
  // non intercetta nulla e non rallenta lo scorrimento.
  document.addEventListener('touchstart', function () {}, { passive: true });

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    if (REDUCED || !('IntersectionObserver' in window)) return;

    // Sections that rise into view. Excludes the header, the announcement bar
    // and anything already running its own choreography.
    var SECTION_SEL = '.shopify-section > .section, .shopify-section > section';
    var SKIP = ['.cons', '.fjny', '.header', '.announcement-bar', '.promo-countdown'];

    function skip(el) {
      for (var i = 0; i < SKIP.length; i++) {
        if (el.closest && el.closest(SKIP[i])) return true;
      }
      return false;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('amar-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    var fold = window.innerHeight * 0.9;

    Array.prototype.slice.call(document.querySelectorAll(SECTION_SEL)).forEach(function (el) {
      if (skip(el)) return;
      // Anything already on screen at load stays put: no reveal on first paint.
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('amar-rise');
      io.observe(el);
    });

    var MEDIA_SEL = '.card-gallery, .product-media, [class*="card-image"]';
    Array.prototype.slice.call(document.querySelectorAll(MEDIA_SEL)).forEach(function (el, idx) {
      if (skip(el) || !el.querySelector('img')) return;
      el.classList.add('amar-media');
      el.style.setProperty('--amar-d', (idx % 4) * 70 + 'ms');
      if (el.getBoundingClientRect().top < fold) {
        el.classList.add('amar-in');
        return;
      }
      io.observe(el);
    });
  });
})();
